export default function DownArrow({ colour = 'text-secondary-blue' }) {
  return (
    <svg
      className={`${colour} text-[2.1875rem] w-[1em] h-[1em] fill-[currentColor] block-inline shrink-0`}
      viewBox="0 0 24 24"
      focusable="false"
    >
      <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path>
    </svg>
  );
}
